import React, {InputHTMLAttributes} from 'react';
import cn from 'classnames';

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
    id?: string;
    label?: string;
    error?: string;
    classNameLabel?: string;
    type?: string;
    className?: string;
    placeHolder?: string;
    value?: string;
    isLoading?: boolean;
}

const classes = {
    rootInput:
        'bg-[#FFF] w-full text-[14px] h-[40px] rounded-[4px] py-[10px] px-[12px] gap-[10px] outline-none border-[1px] text-[#2722FB]',
    rootLabel: 'text-[12px] md:text-[14px]',
    rootLabelContainer: `origin-[0] pointer-events-none`,
};

const InputGradient = React.forwardRef<HTMLInputElement, IProps>(
    (
        {
            label,
            error,
            classNameLabel,
            type,
            className,
            placeHolder,
            isLoading,
            name = 'no-name-input',
            disabled,
            ...rest
        },
        ref,
    ) => {
        const inputStyle = cn(classes.rootInput, className, {
            '!bg-[#fff] !opacity-100 appearance-none': disabled,
            'text-[#2722FB]': !disabled,
        });
        const labelStyle = cn(classes.rootLabel, classNameLabel);
        const containerStyle = cn(
            'bg-clip relative flex flex-col rounded-[8px] bg-festival-color_divider bg-gradient-border p-[1px]',
            {
                'opacity-50': disabled,
            },
        );

        return (
            <>
                <span className={classes.rootLabelContainer}>
                    <label htmlFor={name} className={labelStyle}>
                        {label}
                    </label>
                </span>
                <div data-testid="input-gradient" className={containerStyle}>
                    <input
                        name={name}
                        ref={ref}
                        type={type}
                        disabled={disabled}
                        className={inputStyle}
                        placeholder={placeHolder}
                        {...rest}
                    />
                </div>
                {error && (
                    <p data-testid="input-gradient-error" className="mt-2 text-xs text-red-500">
                        {error}
                    </p>
                )}
            </>
        );
    },
);
InputGradient.displayName = 'InputGradient';
export default InputGradient;
